import { useTheme } from "@hooks";

export const Withdraw = () => {
  const { theme } = useTheme();

  const fill = theme.icon.default;

  return (
    <svg width="34" height="35" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_12927_183661)">
        <path
          d="M12.7507 28.8332C15.9145 28.8332 18.5944 27.7353 20.7902 25.5394C22.9861 23.3436 24.084 20.6637 24.084 17.4998C24.084 14.3359 22.9861 11.6561 20.7902 9.46025C18.5944 7.26442 15.9145 6.1665 12.7507 6.1665C9.58676 6.1665 6.9069 7.26442 4.71107 9.46025C2.51523 11.6561 1.41732 14.3359 1.41732 17.4998C1.41732 20.6637 2.51523 23.3436 4.71107 25.5394C6.9069 27.7353 9.58676 28.8332 12.7507 28.8332ZM23.5882 28.4082C26.2562 28.0776 28.4225 26.8557 30.0871 24.7425C31.7517 22.6294 32.584 20.2151 32.584 17.4998C32.584 14.7846 31.7517 12.3703 30.0871 10.2571C28.4225 8.14393 26.2562 6.92206 23.5882 6.5915V8.64567C25.6659 9.02345 27.3305 10.0564 28.5819 11.7446C29.8333 13.4328 30.459 15.3512 30.459 17.4998C30.459 19.6484 29.8333 21.5669 28.5819 23.255C27.3305 24.9432 25.6659 25.9762 23.5882 26.354V28.4082ZM12.7507 26.7082C10.2243 26.7082 8.05794 25.805 6.25169 23.9988C4.44544 22.1925 3.54232 20.0262 3.54232 17.4998C3.54232 14.9734 4.44544 12.8071 6.25169 11.0009C8.05794 9.19463 10.2243 8.2915 12.7507 8.2915C15.277 8.2915 17.4434 9.19463 19.2496 11.0009C21.0559 12.8071 21.959 14.9734 21.959 17.4998C21.959 20.0262 21.0559 22.1925 19.2496 23.9988C17.4434 25.805 15.277 26.7082 12.7507 26.7082Z"
          fill={fill}
        />
        <path d="M9.1543 16.8462H17.0005V18.1539H9.1543V16.8462Z" fill={fill} />
        <path
          d="M13.255 21.0665L9.68841 17.4999L13.2553 13.933L12.0664 12.7441L8.49954 16.311L7.31066 17.4999L8.49953 18.6888L12.0661 22.2554L13.255 21.0665Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_12927_183661">
          <rect width="34" height="34" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
